$(function () {
  var $bird = $('#bird-404'),
  $birdWrapper = $bird.parent();
  $birdWrapper.height($birdWrapper.height());
  
});